import React, { useState, useEffect, useContext } from 'react'
import { OrderContext } from '../context/OrderContext';

export default function useReasonList() {

  const {apiClient, uuid} = useContext(OrderContext);
  const [reason, setReason] = useState()

  




 const dataReason = (product_id)=>{
        const params = {
          order_product_id : product_id
        };
            
          const request_url = Object.entries(params)
              .filter(([_, value]) => Boolean(value)) // truthy değerleri filtrele
              .reduce(
                (url, [key, value]) => url + `&${key}=${value}`,
                `api/v1/refund/${uuid}/list_reasons/?`
      ); 
     
        apiClient.get(request_url)
          .then(({data}) =>{
            setReason(data) 
    })
          .catch(error => console.log('error', error));        
 }





 return {dataReason, reason}
}
